import { withMockQueryClient } from '../../stories/mockQueryClient';
import { iimReviewKeys } from '../../hooks/queryKeys';
import TechPerformanceContextDrawer from './index';
const MOCK_ASSESSMENT = {
    id: 101,
    inspectionId: 1,
    technicianId: 42,
    technicianName: 'Jane Smith',
    rating: 'needs_review',
    score: 62,
    summary: null,
    descriptionMd: null,
    status: 'complete',
    completedAt: null,
    generatedAt: '2026-09-18T10:00:00Z'
};
const MOCK_CONTEXT = {
    this_inspection: {
        duration_minutes: 95,
        custom_rule_findings_count: 3,
        featured_rule_finding: {
            rule_source_id: 7,
            directive_human: 'Deficiency notes must not exceed 500 characters.',
            count: 2
        }
    },
    trend: {
        window_description: 'Last 12 inspections',
        inspections: [
            { inspection_id: 1, date: '2026-09-18', duration_minutes: 95, frequency: 'Annual' },
            { inspection_id: 2, date: '2026-08-15', duration_minutes: 82, frequency: 'Annual' },
            { inspection_id: 3, date: '2026-07-12', duration_minutes: 110, frequency: 'Monthly' }
        ],
        custom_rule_findings_count: 7,
        previous_inspections_count: 2,
        featured_rule_finding_trend: {
            affected_inspections_count: 1,
            window_count: 2
        }
    },
    benchmarks: {
        building_average_duration_minutes: 78,
        building_median_duration_minutes: 85,
        building_median_rule_findings_per_inspection: 1
    }
};
const CONTEXT_KEY = iimReviewKeys.techPerformanceContext(MOCK_ASSESSMENT.technicianId, MOCK_ASSESSMENT.inspectionId);
const seed = (scenario) => withMockQueryClient([{ queryKey: CONTEXT_KEY, scenario }]);
const withContext = (overrides) => seed({ status: 'success', data: Object.assign(Object.assign({}, MOCK_CONTEXT), overrides) });
const meta = {
    title: 'Features/IIMReview/TechPerformanceContextDrawer',
    component: TechPerformanceContextDrawer,
    parameters: {
        layout: 'fullscreen'
    },
    decorators: [seed({ status: 'success', data: MOCK_CONTEXT })],
    args: {
        technicianAssessment: MOCK_ASSESSMENT,
        inspectionId: 1,
        isOpen: true,
        onClose: () => undefined,
        onSeeScorecard: () => undefined
    }
};
export default meta;
export const WithData = {};
export const Loading = {
    decorators: [seed({ status: 'loading' })]
};
export const Error = {
    parameters: {
        docs: {
            description: {
                story: 'The component has no error UI yet, so the drawer body renders empty. Documents a known gap.'
            }
        }
    },
    decorators: [seed({ status: 'error' })]
};
export const Closed = {
    args: {
        isOpen: false
    }
};
export const NoCompanyRulesSkipped = {
    decorators: [
        withContext({
            this_inspection: Object.assign(Object.assign({}, MOCK_CONTEXT.this_inspection), { custom_rule_findings_count: 0, featured_rule_finding: null }),
            trend: Object.assign(Object.assign({}, MOCK_CONTEXT.trend), { custom_rule_findings_count: 0, featured_rule_finding_trend: null })
        })
    ]
};
export const NoFeaturedRule = {
    decorators: [
        withContext({
            this_inspection: Object.assign(Object.assign({}, MOCK_CONTEXT.this_inspection), { featured_rule_finding: null }),
            trend: Object.assign(Object.assign({}, MOCK_CONTEXT.trend), { featured_rule_finding_trend: null })
        })
    ]
};
export const NoFeaturedRuleTrend = {
    decorators: [withContext({ trend: Object.assign(Object.assign({}, MOCK_CONTEXT.trend), { featured_rule_finding_trend: null }) })]
};
export const NoTrendInspections = {
    decorators: [withContext({ trend: Object.assign(Object.assign({}, MOCK_CONTEXT.trend), { inspections: [] }) })]
};
export const SingleTrendPoint = {
    decorators: [
        withContext({
            trend: Object.assign(Object.assign({}, MOCK_CONTEXT.trend), { inspections: MOCK_CONTEXT.trend.inspections.slice(0, 1), previous_inspections_count: 0 })
        })
    ]
};
export const MissingBenchmarks = {
    decorators: [
        withContext({
            benchmarks: {
                building_average_duration_minutes: null,
                building_median_duration_minutes: null,
                building_median_rule_findings_per_inspection: null
            }
        })
    ]
};
